import { Card, Flex, Label, Link, P, Span } from '@fareye/ui'
import {
  AiOutlineExclamationCircle,
  cancelToken,
  FaBell,
  FaBellSlash,
  pascalCase,
  put
} from '@fareye/utils'
import React from 'react'
import {
  CreatedAtStyle,
  FaBellContainer,
  CommentText
} from '../../../../style/styled'
import { getColorOnSeverity } from '../../../../utility/func'
import { IIssue, IIssueListingApiConfig } from '../../../../utility/types'
import CommentsContainer from '../comments/CommentListing'
import { dateFormatterLocal } from '@fareye/utils'
import { severityBackgroundColor, severityColor } from '@fareye/configs'

interface IIssueCardProps {
  issue: IIssue
  baseUrl: string
  config: IIssueListingApiConfig
  resourceType?: string
  isClickable?: boolean
  t: (val: string) => any
}

const IssueCard = ({
  issue,
  config,
  baseUrl,
  isClickable = true,
  resourceType = '',
  t
}: IIssueCardProps) => {
  const source = cancelToken().source()
  const {
    config: { links },
    children: { subscribe }
  } = config
  const [status, setStatus] = React.useState(issue.is_subscribed)
  async function subscribeAndUnsubscribeIssue(
    isSubscribe: boolean,
    threadId: number
  ) {
    try {
      const { apiURL } = subscribe.config.apiConfig
      const url = `${baseUrl}${apiURL}/${threadId}/${
        isSubscribe ? 'subscribe' : 'unsubscribe'
      }`
      await put(url, {}, source.token)
      setStatus(isSubscribe)
    } catch (ex:any) {
      console.error(ex)
    }
  }
  const isMobi = location?.pathname.includes('/v2/view')
  const severity = issue.severity ? issue.severity : 'Low'
  const [showComments, setShowComments] = React.useState(false)
  const textToshow =
    issue.comment_count > 0 ? t('Show Comments') : t('Add Comment')
  const countText = issue.comment_count ? `(${issue.comment_count})` : ''
  const displayTimeSecondFormat = (time: any) =>
    time ? dateFormatterLocal(time, 'ddMMMhhmmA') : '-'
  return (
    <div style={{ padding: '0px 2px' }}>
      <Flex
        justifyContentSpaceBetween
        alignItemsCenter
        bg={(severityBackgroundColor as any)[severity.toLowerCase()]}
        style={{ padding: '5px 6px' }}
      >
        <AiOutlineExclamationCircle
          style={{
            color: '#C84031',
            marginRight: '2px',
            height: '15px',
            width: '15px'
          }}
        ></AiOutlineExclamationCircle>
        {isClickable ? (
          <Link
            to={`${isMobi ? '/v2/view' : ''}${
              links
                ? resourceType
                  ? links[resourceType]
                  : links.tripDetailsUrl
                : ''
            }/${issue.slug || issue.invoice_no}?issueRaised=open`}
          >
            {`${issue.invoice_no}`}
          </Link>
        ) : (
          <Label style={{ fontSize: '14px' }} title={issue.title}>
            {`${t(issue.category)} - ${issue.title}`}
          </Label>
        )}
        <CreatedAtStyle
          style={{ marginLeft: 'auto', marginRight: '1em', fontSize: '12px' }}
        >
          {displayTimeSecondFormat(issue.updated_at)}
        </CreatedAtStyle>
        <Span
          variant="h6"
          style={{
            padding: '5px 6px',
            background:
              (severityColor as any)[severity.toLowerCase()] ??
              'rgb(105, 192, 255)',
            color: '#fff',
            borderRadius: 5,
            fontSize: '12px'
          }}
        >
          {pascalCase(t(severity))}
        </Span>
      </Flex>
      <Flex justifyContentSpaceBetween alignItemsCenter>
        <div style={{ padding: '12px 12px' }}>
          <span style={{ fontSize: '12px' }}>{t('Trip ID') + ': '}</span>
          <span
            style={{ fontSize: '12px', padding: 0, color: 'rgb(0, 75, 145)' }}
          >
            {issue.invoice_no}
          </span>
        </div>
        <P
          onClick={() => setShowComments(!showComments)}
          style={{
            padding: '2px 8px',
            cursor: 'pointer',
            color: '#727272',
            boxShadow: '0px 2px 4px rgba(208, 208, 208, 0.5)',
            borderWidth: '1px',
            borderRadius: '4px',
            borderStyle: 'solid',
            marginLeft: 'auto',
            marginRight: '1px'
          }}
        >
          {!showComments ? (
            <CommentText
              style={{ fontSize: '12px', color: '#727272' }}
            >{`${textToshow} ${countText}`}</CommentText>
          ) : (
            <CommentText style={{ fontSize: '12px', color: '#727272' }}>
              {t('Hide Comments')}
            </CommentText>
          )}
        </P>
        <FaBellContainer
          onClick={() => {
            subscribeAndUnsubscribeIssue(!status, issue.thread_id)
          }}
          style={{ color: '#727272', padding: '5px 6px' }}
        >
          {status ? (
            <FaBell title={t('Subscribed')} />
          ) : (
            <FaBellSlash title={t('Unsubscribed')} />
          )}
        </FaBellContainer>
      </Flex>
      <div>
        <CommentsContainer
          count={issue.comment_count}
          issueId={issue.id}
          threadId={issue.thread_id}
          baseUrl={baseUrl}
          config={config}
          showComments={showComments}
          t={t}
        />
      </div>
    </div>
  )
}
export default IssueCard
